import React, { FC } from 'react';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    actionContainer: {
      marginTop: theme.spacing(5),
      textAlign: 'center',
    },
  });

interface IProps extends WithStyles<typeof styles> {}

const ActionContainer: FC<IProps> = ({ classes, children }) => (
  <div className={classes.actionContainer}>{children}</div>
);

export default withStyles(styles)(ActionContainer);
